import { Component, OnInit } from '@angular/core'; 
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { CrearVlanParametros } from '../shared/models/crear-vlan-parametros';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { SesionService } from '../shared/services/sesion.service';
import { environment } from '../../environments/environment';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;
@Component({
  selector: 'app-crear-vlan-nube',
  templateUrl: './crear-vlan-nube.component.html',
  styleUrls: ['./crear-vlan-nube.component.css']
})
export class CrearVlanNubeComponent implements OnInit {

  principalForm = this.formBuilder.group({
    selectCompania: new FormControl('', Validators.required),
    selectCiudad: new FormControl(),
    selectSede: new FormControl(),
    selectMascara: new FormControl(),
    selectAmbiente: new FormControl(),
    imputVlan: ['', Validators.required],
    textAreaObeservaciones: new FormControl(),
  });

  private codigoListaMascaras = environment.listaCodigoMascara;
  private codigoMascaraCloud = environment.listaItemMascaraCloud;
  mensajeVlanNoCreada = 'No se ha podido crear una VLAN con los parametros seleccionado';
  ciudad:Ciudad=new Ciudad;
  permiso: boolean;
  companias: Compania[];
  companiaSeleccionada: Compania = new Compania();
  ciudades: Ciudad[];
  sedes: Sede[];
  vlans: Vlan[];
  idCompaniaSeleccionada: number;
  idCiudadSeleccionada: number;
  idSedeSeleccionada: number;
  idAmbienteSelecccionado: number;
  idVlanSeleccionado: number;
  ambientes: ListaItem[];
  mascaras: ListaItem[];
  mascarasFiltradas: ListaItem[];
  idMascaraSeleccionada: number;
  nombreVlan: string;
  observaciones: string;
  parametros: CrearVlanParametros = new CrearVlanParametros();
  modalRef: NgbModalRef;
  mensajeAlerta: string;
  cloudSeleccionada = false;
  bandera=false;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal, private formBuilder: FormBuilder,
    private sesionService: SesionService) { }

  ngOnInit() {
    this.ciudad.idCiudad=3;
    this.ciudad.nombreCiudad="CLOUD";
    this.sesionService.permisoCrearVlan().subscribe(
      resultado => this.permiso = resultado
    );
    this.listarCompanias();
    this.listarMascaras();
    this.listarCiudadaesPorCompania();
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public seleccionarCompania(): void {
    for (let i = 0; i < this.companias.length; i++) {
      if (this.companias[i].idCompania == this.idCompaniaSeleccionada) {
        this.companiaSeleccionada = this.companias[i];
      }
    }
  }

  public listarCiudadaesPorCompania(): void {
    if(this.bandera){
      this.seleccionarCompania();
      this.idCiudadSeleccionada = null;
      this.idSedeSeleccionada = null;
      this.idAmbienteSelecccionado = null;
      this.idVlanSeleccionado = null;
      this.ciudades = null;
      this.sedes = null;
      this.ambientes = null;
      this.vlans = null;
      this.idMascaraSeleccionada = null;
      this.ciudadService.ciudadesPorIdCompania(this.companiaSeleccionada.idCompania).subscribe(
        resultado => this.ciudades = resultado
      );
    }
    else{
      this.ciudadService.ciudadesPorIdCompania(2).subscribe(
        resultado => this.ciudades = resultado
      );
    }
    
    this.idCiudadSeleccionada=3;
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.seleccionarCompania();
    this.idSedeSeleccionada = null;
    this.idAmbienteSelecccionado = null;
    this.idVlanSeleccionado = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.idMascaraSeleccionada = null;
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaSeleccionada, this.idCiudadSeleccionada).subscribe(
      resultado => this.sedes = resultado
    );
    this.seleccionaCloud();
    if (this.cloudSeleccionada) {
      this.seleccionarMascaraCloud();
      this.principalForm.controls['selectMascara'].disable();
    } else {
      this.principalForm.controls['selectMascara'].enable();
    }
    this.listarCiudadaesPorCompania();
  }

  public listarAmbientes(): void {
    this.idAmbienteSelecccionado = null;
    this.idVlanSeleccionado = null;
    this.ambientes = null;
    this.vlans = null;
    this.listaItemService.ambientesPorCompaniaSedeValidaDMZ(this.idCompaniaSeleccionada,
      this.idSedeSeleccionada).subscribe(
      resultado => this.ambientes = resultado
    );
  }

  public listarMascaras(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaMascaras).subscribe(
      resultado => this.mascaras = resultado
    );
  }

  public guardarVlan(): void {   
    this.settearParametros();
    swal({
      title: "Procesando",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)
    this.administradorIpService.crearVlan(this.parametros).subscribe(
      resultado => {
        this.parametros = resultado;
        swal("Proceso Exitoso", "VLAN creada correctamente", "success").then(function () {
          // Redirect the user
          window.location.href = "/#/solicitar-ip";
        });
        if (this.parametros.vlanCreada == null ||
          this.parametros.vlanCreada.idVlan == null ) {
            swal("VLAN no creada, validar parámetros y direccionamiento disponible", "", "error").then(function () {
              // Redirect the user
              window.location.reload();
            });          
        } 
      }, error => {
        swal("Se presento un error", "", "error").then(function () {
          // Redirect the user
          window.location.reload();
        })
      }
    );
  }

  public settearParametros(): void {
    this.parametros.idAmbiente = this.idAmbienteSelecccionado;
    this.parametros.idCiudad = this.idCiudadSeleccionada;
    this.parametros.compania = this.companiaSeleccionada;
    this.parametros.idMascara = this.idMascaraSeleccionada;
    this.parametros.idSede = this.idSedeSeleccionada;
    this.parametros.nombreVlan = this.nombreVlan;
    this.parametros.observaciones = this.observaciones == null ? '' : this.observaciones;
  }

  public ocultarModalResultado(): void {
    this.parametros = new CrearVlanParametros();
    this.principalForm.reset();
    this.modalRef.close();
  }

  public seleccionarMascaraCloud(): void {
    const mascaraSeleccionada = this.mascaras.find(
      mascara => mascara.codigoItem == this.codigoMascaraCloud
    );
    this.idMascaraSeleccionada = mascaraSeleccionada.idListaItem;
  }

  public seleccionaCloud() {
    if (this.idCiudadSeleccionada != null) {
      const ciudadSeleccionada = this.ciudades.find(
        ciudad => ciudad.idCiudad == this.idCiudadSeleccionada
      );
      if (ciudadSeleccionada != null
        && ciudadSeleccionada.nombreCiudad.toUpperCase() == 'CLOUD') {
        this.cloudSeleccionada = true;
      } else {
        this.cloudSeleccionada = false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/crear-vlan-nube/crear-vlan-nube.component.ts